import { Tooltip } from 'antd'
import { commaingNumber } from '../../utils'
import { SALES_ROLE as role } from '../../constants/overview'


const leaderBoardTeamMemberSchema = ({data, step}) => {
  let steps = data.overall_step_count !== '-' ? commaingNumber(data.overall_step_count) : <Tooltip placement='bottom' title={`${data.name} has not yet participated in the Stepathon`}>-</Tooltip>
  return (
    <tr className='text-gray-600' key={data.id} >
      <td className={`pl-3 pr-4 py-4 font-semibold ${role === 'sales' && 'filter blur-sm select-none' }`}   style={{width: '30%'}}>{data.name}</td>
      <td className='pl-3 pr-4 py-4' style={{width: '20%'}}> {data.employee_id} </td>
       <td className={`pl-3 pr-4 py-4  ${role === 'sales' && 'filter blur-sm select-none' }`}  style={{width: '30%'}}>{data.email}</td>
       { step && <td className='pl-20 pr-4 py-4 cursor-pointer' style={{width: '20%'}}>{steps}</td> }
    </tr>
  )
}

export default leaderBoardTeamMemberSchema